<template>
  <div class="ps-index-con">
    <div class="banner-con">
      <div class="wrap z-flex z-flex-between">
        <div class="slogan z-flex z-flex-col">
          <div class="slogan-title">您作品突围的形象专家</div>
          <div class="slogan-sub-title">五六公社修向您发出邀请：唤醒您的图库，精修匹配各类赛事！轻松获大奖！</div>
          <div class="btn-group z-flex z-flex-center">
            <el-button class="btn btn-buy" @click="toUrl('/ps/pack')">购买修图包</el-button>
            <el-button class="btn btn-ps" type="primary" @click="toUrl('/ps/submit')">立即修图</el-button>
          </div>
        </div>
        <div class="swiper-box">
          <div class="swiper banner">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item,index) in banner" :key="index" @click="toUrl(item.url, true)">
                <el-image class="img" fit="cover" :src="item.img"></el-image>
              </div>
            </div>
            <div class="swiper-pagination banner-pagination"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="case-con wrap">
      <div class="hd">图片精修案例欣赏</div>
      <div class="bd">
        <div class="item z-flex" v-for="(item,index) in caseList" :key="index">
          <div class="img-con before">
            <el-image class="img" fit="cover" :src="item.before"></el-image>
            <span class="tag">修图前</span>
          </div>
          <div class="img-con after">
            <el-image class="img" fit="cover" :src="item.after"></el-image>
            <span class="tag">修图后</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';
export default {
  components: {
  },
  data() {
    return {
      banner:[
        {
          img: "http://dy-allimage-test.oss-cn-hangzhou.aliyuncs.com/uploads/20220620/f6ed0fa82278567a9d12a0c910cc7135.jpg",
          title: "光彩世界",
          url: "",
        },
      ],
      caseList:[
        {
          before:'https://www.pai2345.com/static/web/res/images/pscase_before3.jpg',
          after:'https://www.pai2345.com/static/web/res/images/pscase_after3.jpg',
        },{
          before:'https://www.pai2345.com/static/web/res/images/pscase_before2.jpg',
          after:'https://www.pai2345.com/static/web/res/images/pscase_after2.jpg',
        },{
          before:'https://www.pai2345.com/static/web/res/images/pscase_before5.jpg',
          after:'https://www.pai2345.com/static/web/res/images/pscase_after5.jpg',
        },
      ],
    };
  },
  computed: {
    
  },
  mounted() {
    this.initSwiper();
  },
  methods: {
    toUrl(url){
      this.$router.push({
        path:url,
      })
    },
    initSwiper(){
      var mySwiper = new Swiper('.banner', {
          autoplay:true,
          pagination: {
            el: '.banner-pagination',
          },
          observer:true, 
          observeParents:true, 
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ps-index-con{
  background: #f5f5f5;
  padding-bottom: 60px;
}
.banner-con{
  width: 100%;
  padding:30px 0;
  background:linear-gradient(to bottom,#fff6f6,#ffdede);
}
.swiper-box{
  padding: 10px;
  background: rgba(255,255,255,.65);
  border-radius: 6px;
  .banner{
    width:800px;
    height:400px;
    border-radius: 6px;
    overflow: hidden;
    position: relative;
    .img{
      width:100%;
      height:100%;
    }
    .banner-pagination{
      color: #fff;
      width: 100%;
      left: 0;
      bottom: 20px;
      ::v-deep .swiper-pagination-bullet-active{
        width: 26px;
        border-radius: 4px;
        background-color: #fff;
      }
      .swiper-pagination-bullet{

      }
    }
  }
}
.slogan{
  flex: 1;
  align-items: flex-start;
  margin-right: 100px;
  .slogan-title{
    font-size: 36px;
    font-weight: 700;
    margin-bottom: 20px;
  }
  .slogan-sub-title{
    font-size: 16;
    color: #777;
    margin-bottom: 20px;
    line-height: 30px;
  }
  .btn-group{
    .btn{
      padding: 15px 30px;
    }
    .btn-buy{
      color: $colorMain;
      background: #FFFFFF;
      border: 1px solid $colorMain;
      &:hover{
        opacity: .85;
      }
    }
  }
}
.case-con{
  margin-top: 60px;
  .hd{
    font-size: 32px;
    text-align: center;
    margin-bottom: 40px;
  }
  .bd{
    .item{
      width: 100%;
      height: 460px;
      margin-bottom: 40px;
      border-radius: 6px;
      overflow: hidden;
      .img-con{
        width:50%;
        height: 100%;
        position: relative;
        .img{
          width:100%;
          height: 100%;
          display: block;
        }
        .tag{
          position: absolute;
          left:10px;
          top: 10px;
          background:rgba(0,0,0,.5);
          color: #fff;
          padding: 4px 10px;
          border-radius: 4px;
        }
      }
    }
  }
}
</style>
